import useTranslation from "next-translate/useTranslation";
import useModal from "../../customHooks/useModal";
import MolhamButton from "./MolhamButton";
import ShareModal from "./ShareModal";
type Props = {
  title: string;
  shareURL: string;
};
const BlogShareBtn = ({ title, shareURL }: Props) => {
  const {
    showModal: showShareModal,
    handleCloseModal: handleCloseShareModal,
    handleShowModal: handleShowShareModal,
  } = useModal();
  const { t } = useTranslation("common");

  return (
    <>
      <MolhamButton
        id="blog-share-btn"
        label={t(`share`)}
        onClick={handleShowShareModal}
        labelClassName={"fs-lg"}
        startIcon="fe-share-2 share-btn fs-lg"
        variant={null}
        className={"text-capitalize bg-faded-primary text-primary mr-2 ml-0"}
      />
      <ShareModal
        title={title}
        shareURL={shareURL}
        showShareModal={showShareModal}
        handleCloseShareModal={handleCloseShareModal}
      />
    </>
  );
};

export default BlogShareBtn;
